
import { useContext } from 'react';
import UserContext from '../../context/UserContext';


const Panel = () => {
  const { user, setUser } = useContext(UserContext);

  // const [lastOrders] = useFetcher(`orders/${user.data.id}`);

  // useEffect(() => {
  //   const fethcer = async () => {
  //     const res = await fetch(`https://hamrahyper.ir/api/orders/${user.data.id}`, {
  //       method: 'GET',
  //       credentials: 'include',
  //       headers: {
  //         'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')
  //           .content,
  //       },
  //     });

  //     // console.log(res);

  //     const data = await res.json();
  //     // console.log(data);
  //   };
  //   fethcer();
  // }, [user]);

  return (
    <div className='w-2/3 my-auto flex flex-col justify-between items-center bg-slate-600 text-white rounded-lg'>
      <h2 className='w-full font-bold text-right self-end p-3 border-b'>
        اطلاعات شخصی
      </h2>

      <div className='w-full flex flex-col justify-between items-end'>
        <div className='flex justify-between items-center p-3 gap-2'>
          <span>{user.data.name || 'ثبت نشده'}</span>
          <span> :نام و نام خانوادگی</span>
        </div>

        <div className='flex justify-between items-center p-3 gap-2'>
          <span>{user.data.email || 'ثبت نشده'}</span>
          <span>:پست الکترونیک</span>
        </div>

        <div className='flex justify-between items-center p-3 gap-2'>
          <span>{user.data.phone || 'ثبت نشده'}</span>
          <span>:شماره تلفن</span>
        </div>
      </div>
    </div>
  );
};

export default Panel;
